import { getViemClients } from "@bracket/contractor-next";
import {
	getContractWithABI,
	getTokenDefinition,
	type ValidChainId,
} from "@bracket/chainography";

import type { Config } from "@wagmi/core";
import type { TokenIdentifier, } from "@bracket/types";



export declare type GetCollateralInfoProps = {
	token: TokenIdentifier;
	config?: Config;
	chainId?: ValidChainId;
};

export declare type GetCollateralInfoResult = {
	collateral: `0x${string}`;
	totalDeposit: bigint;
	whitelisted: boolean;
}

/**
 *
 * @param address - the address of the token
 * @returns
 */
export const getCollateralInfo = async ({
	token,
	config,
	chainId = 1,
}: GetCollateralInfoProps): Promise<GetCollateralInfoResult> => {
	try {
		const [client] = await getViemClients({ chainId, config });
		const [address, abi] = getContractWithABI("BrktETH");
		const tok = getTokenDefinition(token);
		const result = await client.readContract({
			address,
			abi,
			functionName: "getCollateralInfo",
			args: [
				tok.address,
			],
		});

		if(result) {
			return result;
		}

		throw new Error("result is empty.");

	} catch (err) {

		throw new Error(`@bracket/contractor/bracket-escrow::getCollateralInfo has failed - ${err.message}`);
	}

};
